import type { Module, MutationTree } from 'vuex'
import type { IState } from '@/store'

export interface IDownloadsState {
  downloadPercentage: number
}

const state = (): IDownloadsState => ({
  downloadPercentage: 0,
})

const mutations: MutationTree<IDownloadsState> = {
  setPercentage(state, percentage: number) {
    state.downloadPercentage = percentage
  },
}

export const Downloads: Module<IDownloadsState, IState> = {
  namespaced: true,
  state,
  mutations,
}
